// views/comments/utils/commentUtils.js
export function formatDateTimeNoSeconds(iso) {
    if (!iso) return "-";
    try {
        return new Date(iso).toLocaleString("fa-IR", {
            year: "numeric",
            day: "numeric",
            month: "long",
            hour: "numeric",
            minute: "numeric",
        });
    } catch {
        return "-";
    }
}

export function truncateText(text, maxLen = 120) {
    const s = String(text || "").trim();
    if (!s) return "-";
    if (s.length <= maxLen) return s;
    return s.slice(0, maxLen) + "…";
}

export function getTypeLabel(type) {
    const t = Number(type);
    if (t === 5) return "استاد";
    if (t === 6) return "پکیج درسی";
    if (t === 3) return "درس";
    return "-";
}

export function normalizedMediaType(v) {
    const n = Number(v);
    if (!n || n === 0) return 1;
    if ([1, 2, 3, 4].includes(n)) return n;
    return 1;
}

export function getMediaLabel(mediaType) {
    const t = normalizedMediaType(mediaType);
    if (t === 2) return "تصویر";
    if (t === 3) return "ویدیو";
    if (t === 4) return "صوت";
    return "متن";
}

export function getUserFullName(item) {
    const fn = item?.firstName || item?.userInfo?.firstName || "";
    const ln = item?.lastName || item?.userInfo?.lastName || "";
    const joined = [fn, ln].filter(Boolean).join(" ").trim();
    return joined || item?.userInfo?.fullName || "-";
}

export function getProductDisplay(item) {
    if (!item) return "-";

    // اول objectTitle را چک کن
    const objectTitle = String(item?.objectTitle || "").trim();
    if (objectTitle) return objectTitle;

    const type = Number(item?.type || 0);
    const objectId = Number(item?.objectId || 0);

    if (!type || !objectId) return "-";

    // براساس نوع، فیلدهای مربوطه را چک کن
    if (type === 5) {
        const masterName = String(item?.masterFullName || item?.masterName || "").trim();
        if (masterName) {
            // ذخیره در objectTitle برای دفعات بعد
            item.objectTitle = masterName;
            return masterName;
        }
    } else if (type === 3) {
        const lessonTitle = String(item?.lessonTitle || item?.title || "").trim();
        if (lessonTitle) {
            item.objectTitle = lessonTitle;
            return lessonTitle;
        }
    } else if (type === 6) {
        const categoryTitle = String(item?.categoryTitle || item?.title || "").trim();
        if (categoryTitle) {
            item.objectTitle = categoryTitle;
            return categoryTitle;
        }
    }

    // اگر هیچکدام نبود، فرمت پیش‌فرض
    const tp = getTypeLabel(item?.type);
    const oid = item?.objectId ? `#${item.objectId}` : "-";
    if (tp !== "-" && oid !== "-") return `${tp} ${oid}`;
    return oid !== "-" ? oid : "-";
}

export function getContentUrl(item) {
    return String(item?.mediaUrl || "").trim();
}

export function hasMedia(item) {
    const mt = normalizedMediaType(item?.mediaType);
    const url = getContentUrl(item);
    return [2, 3, 4].includes(mt) && !!url;
}

export function getAvatarUrl(item) {
    const url = String(item?.imageUser || item?.userInfo?.imageUser || "").trim();
    return url || "";
}

export function getInitials(item) {
    const fn = String(item?.firstName || "").trim();
    const ln = String(item?.lastName || "").trim();
    const a = fn ? fn[0] : "؟";
    const b = ln ? ln[0] : "";
    return (a + b).toUpperCase();
}